import { callToMessage } from '@central-products/transport-bus-common';
export function isPromise(obj) {
  return obj && typeof obj.then === 'function';
} // @ts-ignore: unused schema param

export function validatePayload(message, schema) {
  // TODO: AJV validation of message (as JSON) with ${schema}
  return message;
}
export function callToValidRequest(meta, domain, serviceName, args) {
  var name = meta.name,
      hasParams = meta.hasParams;
  var result = callToMessage({
    domain: domain,
    serviceName: serviceName,
    name: name,
    hasParams: hasParams,
    args: args
  });
  result = validatePayload(result, '');
  return result;
}
export function responseToValidResult(meta, domain, serviceName, data) {
  var result = {
    serviceName: serviceName,
    name: meta.name,
    domain: domain,
    payload: data
  };
  result = validatePayload(result, '');
  return result.payload;
}
//# sourceMappingURL=utils.js.map